// src/services/dataCache.js - Sık okunan koleksiyonlar için kısa süreli ortak önbellek
//
// users, courses ve departments hemen her admin sayfasında baştan indiriliyordu.
// Burada bir kez indirilip TTL süresince sayfalar arasında paylaşılır.
// Bu koleksiyonlara yazan her yer ilgili anahtarı invalidate etmelidir.

import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

const TTL_MS = 5 * 60 * 1000; // 5 dakika: başka bir admin'in değişikliği en geç bu kadar gecikir

const entries = new Map(); // key -> { promise, time }

function cached(key, loader) {
    const entry = entries.get(key);
    if (entry && Date.now() - entry.time < TTL_MS) return entry.promise;

    const promise = loader().catch((err) => {
        // Hatalı sonucu önbellekte tutma; bir sonraki çağrı yeniden denesin
        entries.delete(key);
        throw err;
    });
    entries.set(key, { promise, time: Date.now() });
    return promise;
}

const docsOf = async (q) => (await getDocs(q)).docs.map(d => ({ id: d.id, ...d.data() }));

// Dönen diziler ve nesneler sayfalar arasında paylaşılır: çağıran taraf
// diziyi sıralamadan/değiştirmeden önce kopyalamalı ([...list]).

/** Tüm kullanıcılar (pasifler dahil): [{ id, ...data }] */
export const getUsers = () => cached('users', () => docsOf(collection(db, 'users')));

/** Tüm eğitimler: [{ id, ...data }] */
export const getCourses = () => cached('courses', () => docsOf(collection(db, 'courses')));

/** Departmanlar ada göre sıralı: [{ id, name }] */
export const getDepartments = () =>
    cached('departments', () => docsOf(query(collection(db, 'departments'), orderBy('name'))));

/** Yalnızca departman adları, sıralı */
export const getDepartmentNames = async () => (await getDepartments()).map(d => d.name);

/**
 * Önbelleği temizler. Anahtar verilmezse hepsi temizlenir.
 * @param {...('users'|'courses'|'departments')} keys
 */
export function invalidate(...keys) {
    if (keys.length === 0) entries.clear();
    else keys.forEach(k => entries.delete(k));
}
